// FeetFirstHome.jsx
import React, { useState } from "react";
import { useNavigate, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import NewsletterSignup from "./NewsletterSignup";
import BusinessProfileForm from './BusinessProfileForm'; 
import { logout } from '../../redux/actions/authActions';

const FeetFirstHome = () => {
  const authState = useSelector(state => state.authReducer);
  const { isLoggedIn } = authState;
    const [userName, setUserName] = useState(authState.user.name);
  
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/feetfirst");
  };

  return (
    <div className="font-sans text-black bg-gradient-to-br bg-white">
      {/* Header */}
      <header className="flex justify-between items-center px-6 py-4 bg-white shadow-md sticky top-0 z-50">
        <div className="text-3xl font-extrabold text-blue-600 tracking-wide">FeetFirst: Podiatry</div>

        {/* Desktop Menu */}
        <nav className="hidden md:flex space-x-6 font-medium">
          <a href="#equipment" className="hover:text-pink-600 transition text-blue-600">Equipments</a>
          <a href="#learning" className="hover:text-pink-600 transition text-blue-600">Digital Academy</a>
          <a href="#whyus" className="hover:text-pink-600 transition text-blue-600">About Us</a>
          <a href="#business" className="hover:text-pink-600 transition text-blue-600">Partners</a>
        </nav>
        <div className="hidden md:flex items-center space-x-4">
          {isLoggedIn ? (
            <>
              <span className="text-blue-600 font-medium">Welcome, {userName}</span>
              <button
                onClick={() => navigate(`/feetfirstdashboard`)}
                className="w-9 h-9 flex items-center justify-center text-lg bg-red-500 text-white rounded-full hover:bg-red-600 transition"
                title="Dashboard"
              >
                🧭
              </button>
              <button
                onClick={handleLogout}
                className="w-9 h-9 flex items-center justify-center text-lg bg-red-500 text-white rounded-full hover:bg-red-600 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="px-4 py-2 text-sm border border-pink-500 text-white rounded-full hover:bg-pink-600 transition"
              >
                Login
              </button>
              <button
                onClick={() => navigate("/signup")}
                className="px-4 py-2 text-sm bg-blue-500 text-white rounded-full hover:bg-pink-600 transition"
              >
                Register
              </button>
            </>
          )}
        </div>

        {/* Mobile Hamburger */}
        <div className="md:hidden flex items-center justify-center w-24">
            <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="text-3xl text-white focus:outline-none bg-pink-500 flex justify-center"
                aria-label="Toggle Menu"
            >
                {isMobileMenuOpen ? "×" : "☰"}
            </button>
        </div>
      </header>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-gray-200 px-6 py-4 space-y-1 text-center">
          {isLoggedIn && (
            <div className="flex flex-col items-center justify-center text-center">
            <p className="text-blue-600 font-medium">Welcome, {userName}</p>
            <div className="flex flex-row space-x-4 mt-2">
              <button
                onClick={() => navigate(`/feetfirstdashboard`)}
                className="w-10 h-10 flex items-center justify-center text-lg bg-red-500 text-white rounded-full hover:bg-red-600 transition"
              >
                🧭
              </button>
              <button
                onClick={handleLogout}
                className="w-10 h-10 flex items-center justify-center text-lg bg-red-500 text-white rounded-full hover:bg-red-600 transition"
              >
                ⏻
              </button>
            </div>
          </div>
          )} 
          <a href="#equipments" className="block hover:text-pink-600 bg-blue-600">Equipments</a>
          <a href="#learning" className="block hover:text-pink-600 bg-blue-600">Digital Academy</a>
          <a href="#whyus" className="block hover:text-pink-600 bg-blue-600">About Us</a>
          <a href="#business" className="block hover:text-pink-600 bg-blue-600">Partners</a>
          {/* <a href="#signup" className="block hover:text-pink-600 bg-blue-600">Newsletter</a> */}
          {!isLoggedIn && (
            <div className="flex justify-center space-x-4 pt-2">
              <button className="px-4 py-2 text-sm border border-pink-500 text-white rounded-full hover:bg-pink-50 transition">Login</button>
              <button className="px-4 py-2 text-sm bg-pink-600 text-white rounded-full hover:bg-pink-700 transition">Register</button>
            </div>
          )}
        </div>
      )}

      {/* Hero Section */}
        <section
        className="relative h-[75vh] sm:h-[90vh] bg-cover bg-center flex items-center justify-center text-white"
        style={{
            backgroundImage: "url('/assets/banners/feetfirst.webp')",
        }}
        >
        {/* Dark overlay for readability */}
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>

        {/* Content container */}
        <div className="relative z-10 text-center px-4 sm:px-6">
            <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-2xl font-bold mb-4 leading-tight">
             Foot & Ankle Health Association (FAHA) Proposed Podiatry & Pedicure Ecosystem for India
            </h1>
            <p className="text-base sm:text-xl md:text-xl mb-6 font-bold">
              Integrating AI, IIoT, BPM and Digital Health
            </p>
            <div className="flex flex-row">
              <button 
                onClick={() => navigate('/feetfirst-catalogue')}
                className="px-6 sm:px-8 py-3 text-blue-600 sm:text-lg font-semibold bg-yellow-200 rounded-full hover:bg-yellow-300 transition-all"
              >
              Take a Tour
              </button>
              <button 
                onClick={() => navigate('/feetfirst-stories')}
                className="ml-4 px-6 sm:px-8 py-3 text-blue-600 sm:text-lg font-semibold bg-yellow-200 rounded-full hover:bg-yellow-300 transition-all"
              >
              Hope Afloat
              </button>
            </div>
        </div>
        </section>


      {/* Equipment Preview */}
      <section id="equipments" className="py-16 px-4 sm:px-6 md:px-20 bg-green-200">
        <h2 className="text-3xl font-bold text-center mb-10 text-pink-600">Products</h2>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {[
            {
              id: 1,
              title: "Romantic Escape to Bali",
              description: "Save 40% · Includes spa + candlelight dinner"
            },
            {
              id: 2,
              title: "Thailand Luxury Overwater Retreat",
              description: "50% Off · Free snorkeling + private butler"
            },
            {
              id: 3,
              title: "Coorg Cottage",
              description: "30% Off · Includes candleligt dinner pass + fondue night"
            }
          ].map((deal) => (
            <div key={deal.id} className="bg-white shadow-md hover:shadow-xl transition rounded-xl overflow-hidden">
              <img 
                src={`/api/downloads/thinktravel/deals/${deal.id}.png`} 
                alt={"Deal Image " + deal.id} 
                className="w-full h-52 object-cover"
              />
              <div className="p-5">
                <h3 className="text-xl font-semibold text-gray-800">{deal.title}</h3>
                <p className="text-gray-600 mt-2">{deal.description}</p>
                <button 
                  onClick={() => navigate(`/feetfirst/${deal.id}`)}
                  className="mt-4 px-5 py-2 bg-pink-500 text-white rounded-full hover:bg-pink-600 text-sm transition">
                  View Deal
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Learning Preview */}
      <section id="learning" className="py-16 px-4 sm:px-6 md:px-20 bg-green-200">
        <h2 className="text-3xl font-bold text-center mb-10 text-pink-600">Podiatry Academy</h2>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {[
            {
              id: 1,
              title: "Romantic Escape to Bali",
              description: "Save 40% · Includes spa + candlelight dinner"
            },
            {
              id: 2,
              title: "Thailand Luxury Overwater Retreat",
              description: "50% Off · Free snorkeling + private butler"
            },
            {
              id: 3,
              title: "Coorg Cottage",
              description: "30% Off · Includes candleligt dinner pass + fondue night"
            }
          ].map((deal) => (
            <div key={deal.id} className="bg-white shadow-md hover:shadow-xl transition rounded-xl overflow-hidden">
              <img 
                src={`/api/downloads/thinktravel/deals/${deal.id}.png`} 
                alt={"Deal Image " + deal.id} 
                className="w-full h-52 object-cover"
              />
              <div className="p-5">
                <h3 className="text-xl font-semibold text-gray-800">{deal.title}</h3>
                <p className="text-gray-600 mt-2">{deal.description}</p>
                <button 
                  onClick={() => navigate(`/feetfirst/${deal.id}`)}
                  className="mt-4 px-5 py-2 bg-pink-500 text-white rounded-full hover:bg-pink-600 text-sm transition">
                  View Deal
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Why Choose Us */}
      <section id="whyus" className="py-16 px-4 sm:px-6 md:px-20 bg-gradient-to-b from-blue-500 to-pink-500">
        <h2 className="text-3xl font-bold text-center mb-10 text-white">Why FeetFirst?</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 text-center">
        {[
            {
            title: "Best Prices",
            emoji: "💰",
            desc: "We negotiate directly with partners to offer unbeatable prices.",
            },
            {
            title: "Verified Partners",
            emoji: "✅",
            desc: "Only trusted, high-quality resorts and hotels make the list.",
            },
            {
            title: "24/7 Support",
            emoji: "📞",
            desc: "Our team is always ready to assist you with your booking journey.",
            },
        ].map((feature, idx) => (
            <div key={idx}>
            <div className="text-5xl mb-4">{feature.emoji}</div>
            <h4 className="text-xl font-semibold mb-2 text-white">{feature.title}</h4>
            <p className="text-white">{feature.desc}</p>
            </div>
        ))}
        </div>
      </section>

      <BusinessProfileForm />

      {/* Newsletter Signup */}
      <NewsletterSignup />

      {/* Footer */}
      <footer className="bg-white text-blue-600 py-10 px-4 sm:px-6 md:px-20">
        <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left">
          <p className="text-sm text-blue-600">&copy; 2025 Think5Whys. All rights reserved.</p>
          <div className="flex space-x-6 mt-4 md:mt-0 text-sm">
            <Link to="/about-us" className="hover:text-pink-400 transition text-blue-600">About</Link>
            <Link to="/privacy-policy" className="hover:text-pink-400 transition text-blue-600">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-pink-400 transition text-blue-600">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-pink-400 transition text-blue-600">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default FeetFirstHome;
